import React from "react";
import { Button } from "components/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faSparkles } from "@fortawesome/pro-solid-svg-icons";
import "./ArtcraftLanding.scss";

// Primary destination — the team has moved to ArtCraft.
const ARTCRAFT_URL =
  "https://getartcraft.com/?utm_source=storyteller.ai&utm_campaign=landing_hero";

export default function ArtcraftLanding() {
  return (
    <section className="artcraft-landing">
      <div className="artcraft-hero">
        <div className="artcraft-eyebrow">
          <FontAwesomeIcon icon={faSparkles} />
          <span>Storyteller AI</span>
        </div>

        <h1 className="artcraft-title">We're Now ArtCraft</h1>

        <p className="artcraft-subtitle">
          ArtCraft is an open source desktop and web app for AI video and image
          generation with 3D scene building to get the exact shot you want.
        </p>

        <div className="artcraft-cta-row">
          <Button
            label="Go to ArtCraft"
            href={ARTCRAFT_URL}
            target="_blank"
            icon={faArrowRight}
            iconFlip={true}
            fontLarge={true}
          />
          <Button
            label="View the legacy site"
            to="/legacy"
            variant="secondary"
            fontLarge={true}
          />
        </div>

        <div className="artcraft-video-wrapper">
          <iframe
            className="artcraft-video"
            src="https://player.vimeo.com/video/1170882965?autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="ArtCraft preview"
            style={{ border: 0 }}
          />
        </div>
      </div>
    </section>
  );
}
